import { render, staticRenderFns } from "./submittedReviews.vue?vue&type=template&id=bd8b7440&scoped=true"
import script from "./submittedReviews.vue?vue&type=script&lang=js"
export * from "./submittedReviews.vue?vue&type=script&lang=js"
import style0 from "./submittedReviews.vue?vue&type=style&index=0&id=bd8b7440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b7440",
  null
  
)

export default component.exports